import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IShoppingListCategory } from '@/interfaces/ShoppingList';
import { IPromotion } from '@/interfaces/Promotion';
import { ICard } from '@/interfaces/Card';
import { ICallToAction, CallToActionType, CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { Partner } from '@/interfaces/Partner';
import { PromotionCarouselItem } from '@/interfaces/PromotionCarouselItem';
import {
    GET_CURRENT_CARD,
    GET_SHOPPING_LIST,
    GET_SHOW_SHOPPING_LIST_CHECKBOXES,
    GET_PROMOTIONS,
    GET_VISIBLE_PROMOTIONS,
    GET_TAB_CTA,
    GET_SWAP_OPEN,
} from '@/store/types';

@Component
export default class ShoppingList extends Vue {
    @Getter(GET_CURRENT_CARD) getCurrentCard!: ICard;

    @Getter(GET_TAB_CTA) getTabCta!: ICallToAction;

    @Getter(GET_SHOPPING_LIST) getShoppingList!: IShoppingListCategory[];

    @Getter(GET_PROMOTIONS) getPromotions!: PromotionCarouselItem[];

    @Getter(GET_VISIBLE_PROMOTIONS) getVisiblePromotions!: IPromotion[];

    @Getter(GET_SHOW_SHOPPING_LIST_CHECKBOXES) showShoppingListCheckboxes!: boolean;

    @Getter(GET_SWAP_OPEN) getSwapOpen!: boolean;

    get position(): CallToActionPosition {
        return CallToActionPosition.TAB;
    }

    get showCheckoutTotal(): boolean {
        return this.getTabCta.showCheckoutTotal;
    }

    get ctaType(): CallToActionType {
        return this.getTabCta.ctaType;
    }

    get showCTA(): boolean {
        return this.getTabCta.ctaType !== 'none';
    }

    get url(): string {
        return this.ctaType === CallToActionType.PARTNER
            ? (this.getCurrentCard.callToActionUrl || '')
            : this.getTabCta.url;
    }

    get subject(): string {
        return this.getTabCta.emailSubject;
    }

    get body(): string {
        return this.getTabCta.emailBody;
    }

    get partner(): Partner {
        return this.getTabCta.partner;
    }

    get label() {
        return this.getTabCta.label;
    }

    get isSwapComponentOpen() {
        if(!this.getSwapOpen){
            return 'is-visible';
        }
        return 'is-hidden';
    }
}
